import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { alpha } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";

import { PATH_DASHBOARD } from "src/routes/paths";
import axios from "src/utils/axios";
import AccountPopover from "./AccountPopover";

export default function MenuCommon({ isDark }) {
  const [showSearchInput, setShowSearchInput] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [suggestionOptions, setSuggestionOptions] = useState([]);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname !== PATH_DASHBOARD.search) {
      setSearchKeyword("");
      setShowSearchInput(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (searchKeyword.length > 1) {
      axios
        .get("/search", {
          params: {
            action: "suggest",
            q: searchKeyword,
          },
        })
        .then((response) => {
          const { suggestions } = response.data;
          setSuggestionOptions(suggestions);
        })
        .catch((error) => {
          console.log("Live Search Error: ", error);
        });
    }
  }, [searchKeyword]);

  return (
    <Stack direction="row" spacing={{ xs: 0.5, sm: 2 }} alignItems="center">
      {!showSearchInput && (
        <IconButton
          aria-label="search"
          onClick={() => {
            setShowSearchInput(true);
          }}
        >
          <SearchIcon
            sx={{ color: isDark ? "text.primary" : "text.secondary" }}
          />
        </IconButton>
      )}
      {showSearchInput && (
        <Autocomplete
          autoHighlight
          disableClearable
          options={suggestionOptions}
          // inputValue={searchKeyword}
          onInputChange={(_, value) => {
            setSearchKeyword(value);
          }}
          onChange={(_, value) => {
            navigate(`${PATH_DASHBOARD.search}?q=${value.term}`);
          }}
          filterOptions={(x) => x}
          getOptionLabel={(option) => option.term}
          isOptionEqualToValue={(option, value) => option.term === value.term}
          renderOption={(props, option) => <li {...props}>{option.term}</li>}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                autoFocus
                placeholder="Search…"
                inputProps={{
                  ...params.inputProps,
                  "aria-label": "search-input",
                  sx: {
                    color: isDark ? "text.primary" : "text.secondary",
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <IconButton
                      aria-label="search"
                      onClick={() => setShowSearchInput(false)}
                    >
                      <SearchIcon
                        sx={{
                          color: isDark ? "text.primary" : "text.secondary",
                        }}
                      />
                    </IconButton>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 0,
                  },
                }}
              />
            );
          }}
          sx={{
            minWidth: 200,
            backgroundColor: (theme) =>
              alpha(
                isDark
                  ? theme.palette.common.white
                  : theme.palette.common.black,
                0.15
              ),
            "&:hover": {
              backgroundColor: (theme) =>
                alpha(
                  isDark
                    ? theme.palette.common.white
                    : theme.palette.common.black,
                  0.25
                ),
            },
            "& .MuiOutlinedInput-root": {
              p: 0.5,
            },
          }}
        />
      )}
      <IconButton>
        <Badge color="error" variant="dot">
          <NotificationsIcon
            sx={{ color: isDark ? "text.primary" : "text.secondary" }}
          />
        </Badge>
      </IconButton>
      <AccountPopover />
    </Stack>
  );
}
